import {AbstractModel} from '../abstract-model';
import {Product} from '../product';

export class ProductPriorityProduct extends AbstractModel {
  position: number | null = null;
  product: Product | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    return this;
  }
}
